<template>
  <div class="news-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <commonTop
      :moduleData="moduleData"
    />

    <div class="common-content-box sys-max-width">
      <el-tabs v-model="activeName" v-if="Array.isArray(moduleSecondList) && moduleSecondList.length > 0">
        <el-tab-pane v-for="item in moduleSecondList" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
      </el-tabs>

      <router-view></router-view>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { MODULE_CONFIG } from '@/config/index'
import moduleMixins from '@/mixins/module'
import { isMobile } from '@/utils/index'

export default {
  mixins: [moduleMixins],
  data() {
    return {
      moduleId: MODULE_CONFIG.NEWS,
      activeName: '',
    }
  },
  methods: {
    isMobile,
    goNewsList(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        const targetId = arr[0].id
        this.activeName = targetId

        this.$router.push({
          name: 'news-list',
          params: {
            id: targetId
          }
        })
      }
    }

  },
  watch: {
    activeName(newVal) {
      this.$router.push({
        name: 'news-list',
        params: {
          id: newVal
        }
      })

    },
    moduleSecondList(newVal) {
      const { name } = this.$route

      if (name === 'news') {
        this.goNewsList(newVal)
      }
    },
  },
  created() {
    const { name, params } = this.$route

    if (name === 'news-list') { // 列表
      this.activeName = params.id
    } else {
      this.goNewsList(this.moduleSecondList)
    }
  }
}
</script>

<style lang="scss">
.news-container {
  &.isMobile {
    .el-tabs {
      margin: 0 1.5rem;
    }
  }


}
</style>